<template>
  <v-container>
    <v-row justify='center'>
      <v-col sm='8' md='3'>
        <wc-data-box hideToolbar>
          <v-card-text class='text-center'>
            <h2>
              <span class='primary--text'>CPM </span>
              <span class='info--text text--lighten-2'>2.0</span>
            </h2>
            <br>
            <h4 class='grey--text'>Goodbye!</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color='primary' :to="{ name: 'Login' }">Log back in</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </wc-data-box>
        <br>
        <v-alert v-if='auto' type='info' border='left'>You were automatically logged out due to inactivity</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import auth from '@/api/auth'
import Vue from 'vue'

export default {
  name: 'logout',
  props: ['auto'],
  created () {
    const vm = new Vue()
    vm.$disconnect()
    this.$store.dispatch('closeDrawer')
    auth.logout()
  }
}
</script>
